"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Api = _interopRequireWildcard(require("@/api/category"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 商品分类 model类
 * CategoryModel
 */
var _default = exports.default = {
  normalizeList: function normalizeList(result) {
    if (Array.isArray(result)) return result;
    if (result && Array.isArray(result.list)) return result.list;
    if (result && result.data && Array.isArray(result.data.recordList)) return result.data.recordList;
    return [];
  },
  // 获取商品分类列表 (用于添加商品的form)
  getCategoryTreeSelect: function getCategoryTreeSelect() {
    var _this = this;
    return new Promise(function (resolve, reject) {
      Api.list().then(function (result) {
        var categoryList = _this.normalizeList(result);
        // 格式化分类列表
        var treeData = _this.formatTreeData(categoryList);
        resolve(treeData);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  // 获取商品分类列表 (用于筛选select)
  getListFromScreen: function getListFromScreen() {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      Api.list().then(function (result) {
        // 格式化分类列表
        var resultList = _this2.normalizeList(result);
        // 格式化为 select列表数据
        var selectList = [{
          title: '全部分类',
          key: 0,
          value: 0
        }].concat(_this2.formatTreeData(resultList));
        resolve(selectList);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  /**
   * 格式化分类列表
   * @param {*} list 分类数据源
   * @param {*} disabled
   */
  formatTreeData: function formatTreeData(list) {
    var _this3 = this;
    var disabledParentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var data = [];
    list.forEach(function (item) {
      var itemId = item.category_id || item.id;
      var parentId = item.parent_id || item.pid;
      var children = item.children || item.child || [];
      // 新的元素
      var netItem = {
        title: item.name,
        key: itemId,
        value: itemId
      };
      // 禁用的分类
      if ([itemId, parentId].includes(disabledParentId) || disabled === true) {
        netItem.disabled = true;
      }
      // 递归整理子集
      if (children && children.length) {
        netItem.children = _this3.formatTreeData(children, disabledParentId, netItem.disabled);
      }
      data.push(netItem);
    });
    return data;
  }
};